/**
 * Records the last ReactiveSearch envelope sent to the search proxy, per
 * index alias. Since the translator switch the ES DSL never exists in the
 * browser, so export / bulk-mail / saved-search actions send the recorded
 * envelope to the backend, where the search.envelope middleware translates
 * it into the legacy ES query shape (see boj-laravel
 * app/Http/Middleware/TranslateSearchEnvelope.php).
 */
const envelopes = {};

/**
 * transformRequest hook for <reactive-base>: stash the outgoing envelope
 * and pass the request through untouched.
 *
 * ReactiveSearch sends one request per executing component: the result
 * list's request carries itself plus every `react` dependency, while a
 * text-search or facet component fires a smaller request of its own. The
 * entries are therefore merged by component id instead of replaced, so the
 * result component is never dropped just because a facet queried last. A
 * filter change always re-sends the result component with all of its
 * dependencies, which refreshes every merged entry.
 */
export function searchRecorder(index) {
  return (request) => {
    try {
      const body = typeof request.body === 'string' ? JSON.parse(request.body) : request.body;
      if (body && Array.isArray(body.query)) {
        const merged = envelopes[index] || {};
        body.query.forEach((entry) => {
          if (entry && entry.id) {
            merged[entry.id] = entry;
          }
        });
        envelopes[index] = merged;
      }
    } catch (e) {
      // Non-JSON request: nothing to record.
    }
    return request;
  };
}

/**
 * The wrapper the backend middleware recognizes. `component` is the
 * componentId whose translated query represents the visible result set.
 */
export function lastEnvelope(index, component = 'SearchResult') {
  return {
    rs_envelope: true,
    index,
    component,
    query: Object.values(envelopes[index] || {}),
  };
}
